// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { edgeware as _edgeware } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the edgeware chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2021
 * Chain Name: Edgeware EdgeEVM Mainnet
 * Default Block Explorer: https://edgscan.live
 * Default RPC URL: https://edgeware-evm.jelliedowl.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { edgeware } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: edgeware,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const edgeware = createCommon({
	..._edgeware,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
